import React from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { ReactComponent as ArrowLeft } from "bootstrap-icons/icons/arrow-left.svg";
import Spinner from "../spinner/Spinner";
import { useVendorPaymentById } from "../../hooks/useInventory";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";

const VendorPaymentShow = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paymentId = searchParams.get("id");

  const { data, isLoading } = useVendorPaymentById(paymentId);

  const payment = data?.data;

  return (
    <MainLayouts>
      <div className="p-6">
        <div className="flex items-center gap-4 mb-6">
          <button onClick={() => navigate("/head-office/inventory/vendor-payments")} className="text-orange1 hover:text-orange-600">
            <ArrowLeft className="w-6 h-6" />
          </button>
          <h1 className="text-2xl font-bold">Payment Details</h1>
        </div>

        {isLoading ? (
          <Spinner loading />
        ) : !payment ? (
          <div className="bg-white rounded-lg shadow p-6 text-center text-red-500">Payment not found.</div>
        ) : (
          <>
            {/* Header card */}
            <div className="bg-white rounded-lg shadow p-6 mb-4">
              <div className="flex flex-wrap justify-between items-start gap-4">
                <div>
                  <p className="text-gray-500 text-sm mb-1">Payment Reference: {payment.payment_reference}</p>
                  <p className="text-gray-500 text-sm mb-1">Order #: {payment.order_number || "—"}</p>
                  <h2 className="text-xl font-bold">{payment.vendor?.name || "—"}</h2>
                </div>
                <div className="text-right">
                  <p className="text-3xl font-bold text-green-700">
                    <CurrencyFormatter amount={parseFloat((payment.amount || "0").toString().replace(/,/g, ""))} />
                  </p>
                  <p className="text-xs text-gray-500 mt-1">Amount Paid</p>
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-6 border-t border-gray-100">
                {[
                  ["Payment Date", payment.payment_date || "—"],
                  ["Vendor", payment.vendor?.name || "—"],
                  ["Bank Account", payment.bank_account ? `${payment.bank_account.bank_name} – ${payment.bank_account.account_name}` : "—"],
                  ["Account Number", payment.bank_account?.account_number || "—"],
                ].map(([label, value]) => (
                  <div key={label}>
                    <p className="text-xs text-gray-500 uppercase tracking-wide">{label}</p>
                    <p className="text-sm font-semibold text-gray-900 mt-0.5">{value}</p>
                  </div>
                ))}
              </div>

              {payment.narration && (
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <p className="text-xs text-gray-500 uppercase tracking-wide">Narration</p>
                  <p className="text-sm text-gray-700 mt-0.5">{payment.narration}</p>
                </div>
              )}
            </div>

            {/* Linked Admin Purchase */}
            {payment.admin_purchase && (
              <div className="bg-white rounded-lg shadow p-6 mb-4">
                <h2 className="font-semibold text-gray-800 mb-4">Linked Purchase Order</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {[
                    ["Purchase Number", payment.admin_purchase.purchase_number],
                    ["Total Amount", <CurrencyFormatter amount={parseFloat((payment.admin_purchase.total_amount || "0").toString().replace(/,/g, ""))} />],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <p className="text-xs text-gray-500 uppercase tracking-wide">{label}</p>
                      <p className="text-sm font-semibold text-gray-900 mt-0.5">{value}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Branch Purchase (if exists) */}
            {payment.branch_purchase && (
              <div className="bg-white rounded-lg shadow p-6 mb-4">
                <h2 className="font-semibold text-gray-800 mb-4">Linked Branch Purchase</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                  {[
                    ["Purchase Number", payment.branch_purchase.purchase_number],
                    ["Total Amount", <CurrencyFormatter amount={parseFloat((payment.branch_purchase.total_amount || "0").toString().replace(/,/g, ""))} />],
                  ].map(([label, value]) => (
                    <div key={label}>
                      <p className="text-xs text-gray-500 uppercase tracking-wide">{label}</p>
                      <p className="text-sm font-semibold text-gray-900 mt-0.5">{value}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </MainLayouts>
  );
};

export default VendorPaymentShow;